// extracted by mini-css-extract-plugin
export var label = "styles-module--label--rz34W";
export var numberGrid = "styles-module--numberGrid--2Wboo";
export var numberElement = "styles-module--numberElement--2ov79";
export var numberLabel = "styles-module--numberLabel--26PdP";
export var number = "styles-module--number--2mHcF";
export var unit = "styles-module--unit--3NqCL";
export var comment = "styles-module--comment--1RRFJ";